import * as React from "react";
import { useEffect } from "react";
import {
  Card,
  CardActionArea,
  CardContent,
  Typography,
  Grid,
  CardMedia,
  Box,
} from "@mui/material";

import "./UserLogin.css";
import "./MemberMain.css";
import axios from "axios";

//  use point screen

export default function MemberScore() {
  //const [score, setScore] = React.useState(0);

  const [itemData, setItemData] = React.useState([]);
  //const [reload, setReload] = React.useState([]);

  const u = localStorage.getItem("bpsoft_score_membercode");

  async function GetItem() {
    //setLoading(true);
    //console.log(u);

    axios({
      method: "post",
      url: process.env.REACT_APP_URL + "/score_get_score.php",
      data: { custcode: u },
    })
      .then(function (response) {
        //console.log(response);

        setItemData(response.data);
        //setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  useEffect(() => {
    GetItem();
  }, [0]);

  return (
    <div>
      {itemData.map((item) => (
        <Grid container spacing={1} sx={{ paddingTop: 2 }}>
          <Grid
            // item
            className="font-link"
            xs={6}
            key={item.id}
            onClick={() => {}}
          >
            <CardMedia
              component="img"
              sx={{
                border: 1,
                borderColor: "grey.500",
                //borderRadius: "5px",
               // height: "180px",
              }}
              alt={""}
              src={
                item.pic_name === ""
                  ? process.env.REACT_APP_URL + "/upload/logo.png"
                  : process.env.REACT_APP_URL + "/upload/" + item.pic_name
              }
            />
          </Grid>
          <Grid //</div>
            //item
            className="font-link"
            xs={6}
            sx={{ paddingLeft: 2 }}
          >
            <Box
              sx={{
                color: "#808080",
                fontSize: "10pt",
              }}
            >
              {item.datecreate2}
            </Box>

            <Box
              sx={{
                color: "blue",
                fontSize: "12pt",
              }}
            >
              {item.itemcode}
            </Box>
            <Box
              sx={{
                color: "blue",
                fontSize: "10pt",
              }}
            >
              {item.warrantyno}
            </Box>
            <Box
              sx={{
                color: "red",
                fontSize: "10pt",
              }}
            >
              {Number(item.score).toLocaleString()} คะแนน
            </Box>

            <Box
              sx={{
                color: "red",
                fontSize: "10pt",
              }}
            >
              {item.isstatus === "N" ? "ยกเลิก (ส่งสินค้าคืนบริษัท)" : ""}
            </Box>
          </Grid>
        </Grid>
      ))}

      <br />
      <br />
      <br />
    </div>
  );
}
